import { FC, ReactNode, useContext } from "react";

import Stack from "@mui/material/Stack";

import { TranslationLineLabelsContext } from "./TranslationLineLabelsContext";

interface TranslationLineProps {
  children: [ReactNode, ReactNode];
  languageLabels?: [ReactNode, ReactNode];
}

export const TranslationLine: FC<TranslationLineProps> = ({ children, languageLabels }) => {
  const contextLabels = useContext(TranslationLineLabelsContext);
  const labels = languageLabels ?? contextLabels;

  return (
    <Stack direction={{ xs: "column", md: "row" }} gap={3} sx={{ width: "100%", minWidth: 0 }}>
      {children.map((child, index) => (
        <Stack key={index} gap={2} sx={{ flex: 1, minWidth: 0 }}>
          {labels?.[index] && <Stack sx={{ display: { xs: "flex", md: "none" } }}>{labels[index]}</Stack>}
          {child}
        </Stack>
      ))}
    </Stack>
  );
};
